
<pgs-loading></pgs-loading>
<pgs-confirm></pgs-confirm>
<pgs-navbar></pgs-navbar>
<!-- <pgs-dashboard></pgs-dashboard> -->
<router-outlet *ngIf="isAuthenticated | async"></router-outlet>

<div *ngIf="isIframeLogoutVisible" class="logout">
  <iframe width="300" height="300" [src]="logoutUrlSanitized"></iframe>
</div>

<pgs-footer></pgs-footer>
